import React, { useEffect, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import CustomToggle from '../../../../components/CustomToggle';
import InterphoneController, {
  InterphoneAreaType,
} from '../../../../controller/InterphoneController';
import { CurrentStoreContext } from '../../../../controller/StoreController';
import { useToast } from '../../../../controller/ToastController';
import InterphoneEdit from '../interphoneAreaEdit/InterphoneAreaEdit';
import { Style } from './style';
import { useRecoilState } from 'recoil';
import { hotelAreaIdState, useInterphoneState } from '../../../../recoil/interphone';
import InterphoneConfirmModal from '../../../../components/modal/InterphoneConfirmModal';
import { resetRecoil, setRecoil } from 'recoil-nexus';
import AsyncLocalStorage from '../../../../utils/AsyncLocalStorage';

const InterphoneAreaIndex = () => {
  const showToast = useToast();
  const { currentStore } = useOutletContext<CurrentStoreContext>();

  const [useInterphone, setUseInterphone] = useRecoilState<boolean>(useInterphoneState);
  const [areaList, setAreaList] = useState<InterphoneAreaType[]>([]);

  const [selectedArea, setSelectedArea] = useState<InterphoneAreaType | null>(null);

  const [visibleConfirm, setVisibleConfirm] = useState<boolean>(false);
  const [submitItem, setSubmitItem] = useState<InterphoneAreaType | null>(null);

  // API
  // 인터폰 사용 여부 변경
  const setInterphoneUseStatus = async () => {
    try {
      const oParams = {
        hotel_id: currentStore.value,
        status: useInterphone ? 0 : 1,
      };
      const oRes = await InterphoneController.setInterphoneUseStatus(oParams);

      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log('setInterphoneUseStatus', oResponse);
        if (oResponse.data && oResponse.data.setResult) {
          showToast(useInterphone ? '인터콤 사용을 해제했어요' : '인터콤 사용을 활성화했어요');
          setUseInterphone(!useInterphone);
        }
      }
    } catch (err) {
      console.log('setInterphoneUseStatus err---->', err);
    }
  };

  // 호텔 구역 리스트 불러오기
  const hotelAreaList = async () => {
    try {
      const oParams = {
        hotel_id: currentStore.value,
      };
      const oRes = await InterphoneController.hotelAreaList(oParams);

      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log('hotelAreaList', oResponse);
        if (oResponse.data && oResponse.data.hotelAreaData) {
          setAreaList(oResponse.data.hotelAreaData);
          const selectedArea: InterphoneAreaType | undefined = oResponse.data.hotelAreaData.find(
            (item: InterphoneAreaType) => item.registerByThisDevice === true,
          );
          console.log('selectedArea', selectedArea);
          if (selectedArea) {
            setRecoil(hotelAreaIdState, selectedArea.hotel_area_id);
            AsyncLocalStorage.setItem('hotelAreaId', JSON.stringify(selectedArea.hotel_area_id));
          } else {
            resetRecoil(hotelAreaIdState);
            AsyncLocalStorage.removeItem('hotelAreaId');
          }
        }
      }
    } catch (err) {
      console.log('hotelAreaList err---->', err);
    }
  };

  // 현재 기기에 구역 설정
  const registerFcmForHotelArea = async (item?: InterphoneAreaType) => {
    try {
      const params = {
        hotel_area_id: item ? item.hotel_area_id : submitItem?.hotel_area_id,
      };
      const response = await InterphoneController.registerFcmForHotelArea(params);
      setSubmitItem(null);
      if (response && response.data) {
        const oRes = response.data;
        if (oRes.data && oRes.data.result) {
          showToast('장소를 지정했어요');
          hotelAreaList();
        }
      } else {
        showToast('알림 허용 후 다시 시도해주세요', 'error');
      }
    } catch (err) {
      console.log('err-->', err);
      showToast('알림 허용 후 다시 시도해주세요', 'error');
    }
  };

  // 현재 기기에 구역 설정 해제
  const unregisterFcmIdFromHotelArea = async (item: InterphoneAreaType) => {
    try {
      const params = {
        hotel_area_id: item.hotel_area_id,
      };
      const response = await InterphoneController.unregisterFcmIdFromHotelArea(params);
      if (response && response.data) {
        const oRes = response.data;
        if (oRes.data && oRes.data.result) {
          showToast('장소를 해제했어요');
          hotelAreaList();
        }
      } else {
        showToast('다시 시도해주세요.', 'error');
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  const handleToggleEvent = (item: InterphoneAreaType) => {
    if (item.registerByThisDevice) {
      unregisterFcmIdFromHotelArea(item);
    } else {
      if (item.registerDeviceCount > 0) {
        setSubmitItem(item);
        setVisibleConfirm(true);
      } else {
        registerFcmForHotelArea(item);
      }
    }
  };

  const selectArea = (item: InterphoneAreaType) => {
    setSelectedArea(item);
  };

  const onCloseConfirmModal = () => {
    setVisibleConfirm(false);
  };
  const onConfirmConfirmModal = () => {
    registerFcmForHotelArea();
    setVisibleConfirm(false);
  };

  useEffect(() => {
    hotelAreaList();
  }, []);

  return (
    <>
      <Style>
        <div className="contentContainer">
          <div className="title initial">
            <h4>인터콤 사용</h4>
            <CustomToggle
              toggleItem={useInterphone}
              onChange={setInterphoneUseStatus}
              activeColor="#4dd2ae"
            />
          </div>
        </div>
        <div className={`contentContainer`}>
          <InterphoneEdit
            selectedArea={selectedArea}
            setSelectedArea={setSelectedArea}
            hotelAreaList={hotelAreaList}
          />
        </div>
        <div className={`contentContainer`}>
          <h4>장소 목록</h4>
          <div className="warningSign">
            <img src={`${process.env.PUBLIC_URL}/svg/ic_warning.svg`} alt="ic" />
            <p>한 개의 기기에 한 개의 장소만 등록 가능합니다</p>
          </div>
          <div className="roomListWrap">
            {areaList.length > 0 ? (
              areaList.map((item, index) => (
                <div key={index} className="roomListBox">
                  <div className="header">
                    <div className="flex">
                      <div className="numberBox">
                        <p>{index + 1}</p>
                      </div>
                      <h2>{item.name}</h2>
                    </div>
                    <div className="flex">
                      <p>해당 기기로 설정</p>
                      <CustomToggle
                        toggleItem={item.registerByThisDevice}
                        onChange={() => handleToggleEvent(item)}
                        activeColor={'#4dd2ae'}
                      />
                    </div>
                  </div>
                  <div className="content">
                    <div className="textWrap">
                      <div className="flex">
                        <h5>설명</h5>
                        <h4>{item.description}</h4>
                      </div>
                      {item.card_title && (
                        <div className="flex">
                          <h5>호텔 컨텐츠</h5>
                          <h4>{item.card_title}</h4>
                        </div>
                      )}
                    </div>
                    <div className="flex">
                      <button>
                        <img
                          src={`${process.env.PUBLIC_URL}/svg/ic_edit.svg`}
                          alt="edit"
                          onClick={() => selectArea(item)}
                        />
                      </button>
                      <button>
                        <img
                          src={`${process.env.PUBLIC_URL}/svg/ic_trashcan.svg`}
                          alt="delete"
                          onClick={() => {}}
                        />
                      </button>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="roomListBox noneList">
                <h2>장소를 등록해주세요</h2>
              </div>
            )}
          </div>
        </div>
      </Style>
      <InterphoneConfirmModal
        isOpen={visibleConfirm}
        modalType={'cancel'}
        icon={`${process.env.PUBLIC_URL}/svg/ic_phone.svg`}
        iconClass="call"
        title={'다른 기기에 등록된 장소입니다.\n해제하고 이 기기로 등록할까요?'}
        description=""
        onConfirmText={'네, 등록할게요'}
        onCancelText={'네, 등록할게요'}
        onConfirm={onCloseConfirmModal}
        onCancel={onConfirmConfirmModal}
        onClose={onCloseConfirmModal}
      />
    </>
  );
};

export default InterphoneAreaIndex;
